module.exports = __webpack_public_path__ + "assets/img/thumb-Super-Obvious-Landing-Page.84ca2bdc.webp";